<template>
    <div class="kzevb-prices">

        <div style="margin-top: 16px">
            <div class="success-box"
                 v-if="successBox.show"
                 v-html="successBox.text">
            </div>
            <div class="error-box"
                 v-if="errorBox.show"
                 v-html="errorBox.text">
            </div>
        </div>

        <table>
            <tr>
                <td>[kurzzeit-evb.de] Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVB" />
                </td>
            </tr>
            <tr>
                <td>[kurzzeit-evb.de] Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVB_GREEN_CARD" />
                </td>
            </tr>
            <tr>
                <td>[kurzzeit-evb.de] (Reseller) Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVB_RESELLER" />
                </td>
            </tr>
            <tr>
                <td>[kurzzeit-evb.de] (Reseller) Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVB_GREEN_CARD_RESELLER" />
                </td>
            </tr>

            <tr>
                <td colspan="2">
                    <hr>
                </td>
            </tr>

            <tr>
                <td>[evb-kurzzeit.de] Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVBKZ_EVB" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeit.de] Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVBKZ_EVB_GREEN_CARD" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeit.de] (Reseller) Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVBKZ_EVB_RESELLER" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeit.de] (Reseller) Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVBKZ_EVB_GREEN_CARD_RESELLER" />
                </td>
            </tr>

            <tr>
                <td colspan="2">
                    <hr>
                </td>
            </tr>

            <tr>
                <td>[evb-kurzzeitkennzeichen.de] Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.KKEVB_EVB" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeitkennzeichen.de] Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.KKEVB_EVB_GREEN_CARD" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeitkennzeichen.de] (Reseller) Kurzzeitkennzeichen Versicherung für Deutschland</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.KKEVB_EVB_RESELLER" />
                </td>
            </tr>
            <tr>
                <td>[evb-kurzzeitkennzeichen.de] (Reseller) Kurzzeitkennzeichen Versicherung inkl. grüner Karte für Europa</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.EVBKZ_EVB_GREEN_CARD_RESELLER" />
                </td>
            </tr>

            <tr>
                <td>MWST</td>
                <td>
                    <input type="number" step=".01" v-model.number="prices.MWST" />%
                </td>
            </tr>
        </table>

        <div>
            <button @click="save">Save</button>
        </div>
    </div>
</template>

<script>

import auth_required from "@/mixins/auth_required";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import success_error_states from "@/mixins/success_error_states";
import {handle} from "@/decorators";

export default {
    name: "prices",
    mixins: [auth_required, success_error_states],
    data: () => ({
        prices: {},
    }),
    computed: {
    },
    methods: {
        @handle("AkvPrices are saved")
        async save() {
            await this.$services.kzevb.updatePrices(this.prices)
        }
    },
    async mounted() {
        this.prices = await this.$services.kzevb.getPrices();
    },
    components: { DatePicker },
}

</script>

<style lang="stylus" scoped>
    .kzevb-prices
        padding 10px

        &__result
            margin-top 15px

    button
        height 34px
        width 60px
        font-weight bold
</style>
